/* global L, snMapLocale */

import 'leaflet';
import 'leaflet-gesture-handling';

const snMap = {
  osmUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  osmAttrib:
    'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
  init: (mapID) => {
    const mapEl = document.getElementById(mapID);
    let mapOptions = null;
    try {
      mapOptions = JSON.parse(mapEl.dataset.snmap);
    } catch (SyntaxError) {
      return false;
    }

    // Modify Icon Image Path
    L.Icon.Default.prototype.options.imagePath = snMapLocale.imagePath;

    const coordinates = mapOptions.coordinates
      .split(',')
      .map((c) => parseFloat(c.trim()));

    const map = new L.Map(mapEl, { gestureHandling: true }).setView(
      coordinates,
      mapOptions.initialZoom,
    );

    L.tileLayer(snMap.osmUrl, {
      maxZoom: mapOptions.maxZoom,
      minZoom: mapOptions.minZoom,
      attribution: snMap.osmAttrib,
    }).addTo(map);

    if (mapOptions.marker) {
      const marker = L.marker(coordinates).addTo(map);
      marker.bindPopup(mapOptions.markerLabel);

      if (mapOptions.showMarker) {
        marker.openPopup();
      }
    }

    return true;
  },
};

document.addEventListener('DOMContentLoaded', () => {
  const maps = document.querySelectorAll('.snmap-map');

  for (let i = 0; i < maps.length; i += 1) {
    const map = maps[i];
    const success = snMap.init(map.id);
    if (!success) {
      map.innerHTML = snMapLocale.errorText;
    }
  }
});
